export default "__VITE_ASSET__c8f9820c__"